"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle16"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBPopover = require("../HBPopover/HBPopover.styles");
var _shared = require("../../utils/shared.utils");
var HBInfoIcon = function HBInfoIcon(_ref) {
  var tooltip = _ref.tooltip,
    _ref$icon = _ref.icon,
    InfoIcon = _ref$icon === void 0 ? _InfoCircle["default"] : _ref$icon,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? _colors["default"].textTertiary : _ref$iconColor,
    _ref$iconHoverColor = _ref.iconHoverColor,
    iconHoverColor = _ref$iconHoverColor === void 0 ? _colors["default"].textSecondary : _ref$iconHoverColor,
    _ref$keepOpenOnHover = _ref.keepOpenOnHover,
    keepOpenOnHover = _ref$keepOpenOnHover === void 0 ? false : _ref$keepOpenOnHover,
    tooltipEnableInitialOpen = _ref.tooltipEnableInitialOpen,
    tooltipShouldSupportClickOutside = _ref.tooltipShouldSupportClickOutside,
    onTooltipOpen = _ref.onTooltipOpen;
  if (!tooltip) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line styled-components-a11y/no-static-element-interactions
    _react["default"].createElement(Container, {
      $tooltipIconHoverColor: iconHoverColor,
      onClick: _shared.stopEventPropagation,
      onKeyPress: _shared.stopEventPropagation
    }, /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
      placement: "top",
      isTargetContainerFocusable: true,
      target: /*#__PURE__*/_react["default"].createElement(InfoIcon, {
        color: iconColor
      }),
      keepOpenOnHover: keepOpenOnHover,
      enableInitialOpen: tooltipEnableInitialOpen,
      shouldSupportClickOutside: tooltipShouldSupportClickOutside,
      onOpenChange: onTooltipOpen && function (_ref2) {
        var isOpen = _ref2.isOpen;
        if (isOpen) {
          onTooltipOpen();
        }
      }
    }, tooltip))
  );
};
var _default = exports["default"] = HBInfoIcon;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBInfoIcon__Container",
  componentId: "sc-122khza-0"
})(["display:inline-flex;width:fit-content;height:fit-content;", "{display:grid;i,&:before{display:flex;grid-area:1 / 1;}i svg *{transition:fill 0.2s;}&:hover i svg *{fill:", ";}&:before{content:'';display:block;margin:-4px;}}"], _HBPopover.TargetContainer, function (props) {
  return props.$tooltipIconHoverColor;
});
//# sourceMappingURL=HBInfoIcon.js.map